/* Once More Wear — tema Maison: indice del catalogo, negozio, domande frequenti (home). */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const subs = [];
  let queued = false;
  const run = () => { queued = false; subs.forEach((fn) => fn()); };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(run); } };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  const onScroll = (fn) => { subs.push(fn); queue(); };

  /* ---------------- striscia di foto: colonne pari leggermente sfalsate ---------------- */
  $$('[data-gal]').forEach((sec) => {
    if (REDUCED) return;
    onScroll(() => {
      const r = sec.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < -100 || r.top > vh + 100) return;
      const p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      sec.style.setProperty('--gp', (p * 2 - 1).toFixed(3));
    });
  });

  /* ---------------- catalogo: le foto di ogni voce scorrono ---------------- */
  $$('[data-cat]').forEach((tile) => {
    const media = $('.cat__media', tile);
    const imgs = media ? $$('.cat__img', media) : [];
    const bar = $('.cat__bar', tile);
    if (imgs.length < 2 || REDUCED) return;
    let i = 0, timer = null;
    const show = (k) => {
      imgs[i].classList.remove('is-on'); i = k; imgs[i].classList.add('is-on');
      media.dataset.i = i;
      if (bar) bar.style.setProperty('--cb', ((i + 1) / imgs.length).toFixed(3));
    };
    const start = () => {
      if (timer) return;
      tile.classList.add('is-live');
      imgs.forEach((im) => { if (im.loading === 'lazy') im.loading = 'eager'; });
      show((i + 1) % imgs.length);
      timer = setInterval(() => show((i + 1) % imgs.length), 750);
    };
    const stop = (reset) => {
      clearInterval(timer); timer = null; tile.classList.remove('is-live');
      if (reset) show(0);
    };
    show(0);
    tile._cat = { start, stop };
    tile.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') start(); });
    tile.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') stop(true); });
    tile.addEventListener('focus', start);
    tile.addEventListener('blur', () => stop(true));
  });
  // su schermi touch scorre il riquadro che sta al centro dello schermo
  if (!window.matchMedia('(hover: hover)').matches && 'IntersectionObserver' in window && !REDUCED) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { const t = en.target._cat; if (!t) return; if (en.isIntersecting) t.start(); else t.stop(false); });
    }, { rootMargin: '-38% 0px -38% 0px', threshold: 0 });
    $$('[data-cat]').forEach((t) => { if (t._cat) io.observe(t); });
  }

  /* ---------------- il negozio: ora di Napoli, scritta a misura, riempimento allo scroll ---------------- */
  $$('[data-shop]').forEach((sec) => {
    const clock = $('[data-clock]', sec), time = $('[data-clock-time]', sec);
    if (clock && time && window.Intl) {
      try {
        const fmt = new Intl.DateTimeFormat('it-IT', { timeZone: 'Europe/Rome', hour: '2-digit', minute: '2-digit' });
        const tick = () => { const d = new Date(); time.textContent = fmt.format(d); time.setAttribute('datetime', d.toISOString()); };
        tick(); clock.hidden = false; setInterval(tick, 15000);
      } catch (err) { /* fuso orario non disponibile: resta nascosto */ }
    }
    const word = $('[data-fit]', sec);
    if (!word) return;
    const line = word.firstElementChild;
    const fit = () => {
      const cs = getComputedStyle(word);
      const avail = word.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      word.style.fontSize = '100px';
      const rg = document.createRange(); rg.selectNodeContents(line);
      const w = rg.getBoundingClientRect().width;
      if (w > 0) word.style.fontSize = `${Math.min(100 * avail / w, window.innerHeight * 0.42).toFixed(2)}px`;
    };
    fit();
    window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    if (REDUCED) { word.style.setProperty('--bp', 1); return; }
    onScroll(() => {
      const r = word.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < -50 || r.top > vh + 50) return;
      const p = clamp((vh - r.top) / (vh * 0.62), 0, 1);
      word.style.setProperty('--bp', p.toFixed(3));
    });
  });

  /* ---------------- domande frequenti: una risposta alla volta ---------------- */
  $$('[data-ask]').forEach((sec) => {
    const btns = $$('[data-ask-btn]', sec);
    if (!btns.length) return;
    const wide = window.matchMedia('(min-width: 1000px)');
    const panelOf = (b) => document.getElementById(b.getAttribute('aria-controls'));
    const select = (b, scroll) => {
      btns.forEach((x) => { const on = x === b; x.setAttribute('aria-pressed', on ? 'true' : 'false'); const p = panelOf(x); if (p) p.hidden = !on; });
      if (scroll && !wide.matches) {
        const p = panelOf(b), r = p && p.getBoundingClientRect();
        if (r && (r.bottom > window.innerHeight || r.top < 0)) p.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'nearest' });
      }
    };
    select(btns[0], false);
    btns.forEach((b) => b.addEventListener('click', () => select(b, true)));
  });

  /* ---------------- vetrina collezioni: schede e didascalia ---------------- */
  $$('[data-showcase]').forEach((sec) => {
    const tabs = $$('[data-show-tab]', sec), panels = $$('[data-show-panel]', sec);
    const all = $('[data-show-all]', sec), cap = $('[data-show-cap]', sec);
    const stagger = (panel) => $$('.show__item', panel).forEach((li, i) => li.style.setProperty('--d', i));
    const select = (t, focus) => {
      tabs.forEach((x) => { const on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; });
      panels.forEach((p) => { const on = p.dataset.showPanel === t.dataset.showTab; p.hidden = !on; p.classList.toggle('is-on', false); if (on) { stagger(p); void p.offsetWidth; p.classList.add('is-on'); p.scrollLeft = 0; } });
      if (all && t.dataset.url) all.href = t.dataset.url;
      if (focus) t.focus();
    };
    panels.forEach(stagger);
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault(); select(tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length], true);
      });
    });
    if (cap) {
      const show = (a) => { cap.innerHTML = ''; if (!a) return; const b = document.createElement('b'); b.textContent = a.dataset.title; cap.append(b, document.createTextNode(a.dataset.price || '')); };
      sec.addEventListener('pointerover', (e) => { const a = e.target.closest('[data-show-thumb]'); if (a) show(a); });
      sec.addEventListener('focusin', (e) => { const a = e.target.closest('[data-show-thumb]'); if (a) show(a); });
      sec.addEventListener('pointerleave', () => show(null));
    }
  });
})();
